import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store/index';
import MainPage from '@/views/MainPage' ;


Vue.use(Router);
//mode: 'history',
const router = new Router({
    routes: [
        {
            path: '/',
            name: 'MainPage',
            component: MainPage,//() => import('@/views/MainPage'),
            meta: {
                requiresAuth: true,
                menu: 'mn_main'
            }
        },
        {
            path: '/login',
            name: 'login',
            // component: Login
            component: () => import('@/views/Login')
        },
        {
            path: '/Catalogs',
            name: 'Catalogs',
            // component: Login
            component: () => import('@/views/CatalogsList')
        },
        {
            path: '/view/:tabName',
            name: 'Table',
            component: () => import('@/views/TableView'),
            props: true,
            meta: {
                requiresAuth: true,
            },
            children: [
                {//просмотр логов
                    path: '/view/log/:tabName/:filter/:value',
                    name: 'ShowLogs',
                    component: () => import('@/views/TableView'),
                    props: true,
                },
                {//просмотр ассетов из календаря
                    path: '/view/calendar/:tabName/:filter/:value',
                    name: 'TableForCalendar',
                    component: () => import('@/views/TableView'),
                    props: true
                },

                {//переходы с графиков главно страницы
                    path: '/view/chart/:tabName/:action/:chart/:filter/:value',
                    name: 'TableWithChart',
                    component: () => import('@/views/TableView'),
                    props: true
                },
            ]
        },
        {//переход по ссылкам, или выбор по одному условию
            path: '/view/detail/:tabName/:action/:filter/:value',
            name: 'TableWithCondition',
            component: () => import('@/views/TableView'),
            props: true
        },
        {
            path: '/asset/:id',
            name: 'AssetPage',
            component: () => import('@/views/AssetPage'),
            props: true,
            meta: {
                requiresAuth: true,
                menu: 'mn_assets'
            }
        },
        {
            path: '/employee/:id',
            name: 'EmployeePage',
            component: () => import('@/views/EmployeePage'),
            props: true,
            meta: {
                requiresAuth: true,
                menu: 'mn_employee'
            }
        },
        {
            path: '/dashboard',
            name: 'Dashboard',
            component: () => import('@/views/Dashboard'),
            props: true,
            meta: {
                requiresAuth: true,
                menu: 'mn_dashboard'
            }
        },

        {
            path: '/User/:id',
            name: 'UserPage',
            component: () => import('@/views/UserPage'),
            props: true,
            meta: {
                requiresAuth: true,
                menu: 'mn_table_user_management'
            }
        },
        {
            path: '*',
            name: '404',
            component: () => import('@/views/Page-404'),
            meta: {
                requiresAuth: true
            }
        },
    ]
});

router.beforeEach((to, from, next) => {
    store.dispatch('storeRouteName', {item: to.name});
    store.dispatch('storeRouteParams', {...to.params, query: to.query});

    if (to.name !== 'login') {
        store.dispatch('storePrevPath', {prevPath: from.path});
    }

    if (to.params && to.params.tabName) {
        store.dispatch('storeCurrentTableName', to.params.tabName);
    }
    //проверим нужна ли вутентификация для перехода
    if (to.matched.some(record => record.meta.requiresAuth) && !sessionStorage.getItem('token')) {
        next({
            path: '/login'
        })
        //проверим есть ли доступ на пункты меню
    } else if (to.meta.menu && !store.getters.isPerimitted(to.meta.menu, 'gui', 'menu')) {
        store.dispatch('storeError', 'You have no permission to this page, please contact with administrator');
        if (from.name === 'login') {
            next('404')
        } else {
            next(false)
        }
        //проверим есть ли доступ на конкретную таблицу
    } else if (to.name === 'Table' && !store.getters.isPerimitted(to.params.tabName, 'view')) {
        store.dispatch('storeError', 'You have no permission to this table, please contact with administrator');
        if (from.name === 'login') {
            next('404')
        } else {
            next(false)
        }
    } else next()
});

export default router;
